import React, { useEffect, useState } from 'react';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from '@mui/icons-material/LocationOn';

function Weather(){
    const [City,setCity]=useState({});
    const [temp,setTemp]=useState({});
    const [Search,setSearch]=useState('mumbai')


   const GetData=async()=>{
    const URL=`https://api.openweathermap.org/data/2.5/weather?q=${Search}&units=metric&appid=148e8ddd024479c3462779b4e96a7a4b`;
   
    const response=await fetch(URL);
    const data = await response.json();

    setCity(data.main);
    setTemp(data.weather[0]);
    }
   useEffect(()=>{
       GetData();
   },[Search])

    return(
        <>

           <h1 className='heading'><LocationOnIcon style={{fontSize: '3rem'}}/> find your location</h1>
           <div className='maindiv'>

               <div className='citydiv'>
               <div className='skydetailC'>
                 <input type='text' placeholder='search' id='inputsearch' value={Search}
                  onChange={(e)=>setSearch(e.target.value)} />
                      <label for="inputsearch"> <SearchIcon/></label>
                 
               </div>
                 <h1 className='searchh1'><LocationSearchingIcon /> {Search}</h1>
                 {
                     !temp?<h2>not found</h2>:(
                     <div className='imgkadiv'>
                        <div className='skydetailC' style={{
                            width: '30%',
                            margin: 'auto'
                        }}>
                     <img src={`http://openweathermap.org/img/w/${temp.icon}.png`} alt='imd' 
                     className='weatherimg' />
                     <h2>{temp.main}</h2>
                     </div>
                     <h3>{temp.description}</h3>
                   </div>
                     )
                 }
                     
                   </div>
                  
               {
                   !City?<h2 className='notfound'>not found</h2>:(
                    <div className='tempdiv'>
                 <h1 style={{fontSize: '2.3rem'}}><ThermostatIcon /> {City.temp}°C</h1>
                 <div className='skydetailC' style={{justifyContent: 'space-around',
                 width: '76%'}}>
                <p className='ppp'>min temp {City.temp_min }°C  </p>
                <p className='ppp'>max temp {City.temp_max }°C</p>
                 </div>
               </div>
                   )
               }
               
           </div>
        </>
    )
}

export default Weather;